import React, { useRef, useState, useEffect } from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import TiltArrow from "../../../../icons/TiltArrow";
import HomeIconSvg from "../../../../icons/HomeIconSvg";
import UserIcon from "../../../../icons/UserIcon";
import BankIcon from "../../../../icons/BankIcon";
import Icon1 from "../../../../icons/BiddingProcess/Icon1";
import Icon2 from "../../../../icons/BiddingProcess/Icon2";
import Icon3 from "../../../../icons/BiddingProcess/Icon3";
import { StartBiddingProcessCard } from "../../../../shadcn/components/custom/StartBiddingProcessCard";
import { PostPropertyCard } from "../../../../shadcn/components/custom/PostPropertyCard";

interface BiddingStepsContent {
  stepNumber: string;
  icon: React.ReactNode;
  title: string;
  details: string;
}

const biddingStepsContent: BiddingStepsContent[] = [
  {
    stepNumber: "01",
    icon: <Icon1 className="h-[34px] w-[34px]" />,
    title: " EMD",
    details: `10% of Reserve Price as Earnest Mony Deposit and KYC Submission
                to get eligibility to participate in auction`,
  },
  {
    stepNumber: "02",
    icon: <Icon2 className="h-[33px] w-[32px]" />,
    title: "E-Auction",
    details: " Participate in the live auction and become successful bidder",
  },
  {
    stepNumber: "03",
    icon: <Icon1 className="h-[34px] w-[34px]" />,
    title: " 100% Payment",
    details: " Comply with Auction Payment Terms of Sale Notice",
  },
  {
    stepNumber: "04",
    icon: <Icon3 className="h-[34px] w-[34px]" />,
    title: "Sale Certificate",
    details: "Collect Documents and complete the sale certificate registration",
  },
];

export default function HowToStartBidding() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [barWidth, setBarWidth] = useState(0);
  const x = 90;

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const updateScrollPosition = () => {
      const scrollPercentage =
        1 *
        (scrollContainer.scrollLeft /
          (scrollContainer.scrollWidth - scrollContainer.clientWidth)) *
        100;
      scrollContainer.style.setProperty(
        "--scroll-position",
        `${2.3 * scrollPercentage}%`
      );
      //   logic for adjusting the width of the background bar

      console.log("Scroll Postion here--->", scrollPercentage);
      setBarWidth(Math.floor(scrollPercentage));
      // if (scrollPercentage > 10) setBarWidth(100);
      // else setBarWidth(90);
    };

    scrollContainer.addEventListener("scroll", updateScrollPosition);
    return () =>
      scrollContainer.removeEventListener("scroll", updateScrollPosition);
  }, []);
  return (
    <div className="">
      <div className="w-full pl-4  lg:px-customPadding mt-4 lg:mt-20 pt-[42px] pb-[98px] lg:py-[50px] 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0 ">
        {/* Heading */}
        <div className="flex items-center">
          <p className="font-spaceGrotesk font-normal text-mobile-h2 leading-[35px] text-brand-textBlack lg:text-web-h2 lg:leading-[57px]">
            HOW TO START THE BIDDING PROCESS
          </p>
        </div>
        {/* Steps */}
        <div className="relative">
          <div
            ref={scrollContainerRef}
            className="flex overflow-x-auto w-full lg:overflow-hidden  gap-[100px] lg:grid lg:grid-cols-4 mt-[42px]  lg:mt-[151px] lg:gap-[93px] custom-scrollbar"
          >
            {biddingStepsContent.map((item, index) => (
              <StartBiddingProcessCard
                key={`card-${index}`}
                stepNumber={item?.stepNumber}
                icon={item?.icon}
                title={item?.title}
                details={item?.details}
                className="z-10 min-w-[224px] pb-[44px] lg:pb-0 lg:w-auto lg:min-w-0"
              />
            ))}

            <div
              className={`absolute border-2 border-[#D6D6D6] ${
                barWidth > 84 ? "w-[72%]" : "w-full"
              }   lg:w-[85%] lg:pr-20 top-[53px]`}

              //   className={`absolute border-2 border-[#D6D6D6] w-[88%] lg:pr-20 top-[53px]`}
            />
            <div
              className="lg:hidden absolute
               custom-scrollbar-track"
            />
          </div>
        </div>

        {/* ORG */}
      </div>
    </div>
  );
}
